import { Loader } from "@googlemaps/js-api-loader";

const contacts = {
  init: function () {
    if ($("#map-wrap").length) {
      const loader = new Loader({
        apiKey: gmap_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        contacts.maps.init($("#map-wrap"));
      });
    }

    if ($("#contact-form").length) {
      contacts.forms.init();
    }

    contacts.popup();
  },

  popup: function () {
    var base_url = window.location.origin + window.location.pathname;
    // On load set state
    var url_params = new URLSearchParams(window.location.search);
    var popup_enabled = url_params.get("popup");
    if (popup_enabled != null) {
      var url = base_url + "?popup=" + popup_enabled;
      history.replaceState(popup_enabled, false, url);
    }

    // Open popup
    $(".button--more").on("click", function (e) {
      e.preventDefault();
      var state = true;
      var url = base_url + "?popup=" + state;
      history.pushState(state, false, url);

      $(".contact-2").removeClass("contacts__hidden");
      $(".contact-1").addClass("contacts__hidden");

      $("html, body").animate(
        {
          scrollTop: 0,
        },
        250
      );
    });

    $(".button--left").click(function (e) {
      e.preventDefault();
      var state = false;
      var url = base_url + "?popup=" + state;
      history.pushState(state, false, url);

      $(".contact-2").addClass("contacts__hidden");
      $(".contact-1").removeClass("contacts__hidden");
    });

    window.onpopstate = function (event) {
      if (event.state) {
        $(".contact-2").removeClass("contacts__hidden");
        $(".contact-1").addClass("contacts__hidden");
      } else {
        $(".contact-2").addClass("contacts__hidden");
        $(".contact-1").removeClass("contacts__hidden");
      }
    };
  },

  maps: {
    elem: false,
    lat: false,
    lng: false,
    pin: false,
    zoom: 16,

    init: function (elem) {
      this.elem = elem;
      var self = this;
      var mapDiv = this.elem[0];

      if ($(mapDiv).data("zoom")) {
        self.zoom = parseInt($(mapDiv).data("zoom"));
      }

      if ($(mapDiv).data("pin")) {
        self.pin = $(mapDiv).data("pin");
      }

      var map = new google.maps.Map(mapDiv, {
        center: {
          lat: $(mapDiv).data("lat"),
          lng: $(mapDiv).data("lng"),
        },
        zoom: self.zoom,
        disableDefaultUI: false,
        scrollwheel: false,
        draggable: true,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: [
          {
            elementType: "labels.text",
            stylers: [{ color: "#ffffff" }, { lightness: -45 }],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#000000" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ color: "#353535" }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ saturation: -100 }, { lightness: -85 }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [
              { color: "#3e3e3e" },
              { lightness: -70 },
              { visibility: "on" },
              { weight: 0.5 },
            ],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ color: "#414141" }],
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{ color: "#1a1a1a" }, { lightness: -100 }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#000000" }, { visibility: "off" }],
          },
          { featureType: "transit", stylers: [{ visibility: "off" }] },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#1a1a1a" }],
          },
        ],
      });

      map.markers = [];

      var center = new google.maps.LatLng(
        $(mapDiv).data("lat"),
        $(mapDiv).data("lng")
      );
      var marker_options = {
        map: map,
        position: center,
        clickable: false,
        animation: google.maps.Animation.DROP,
      };
      if (self.pin) {
        marker_options.icon = self.pin;
      }
      var marker = new google.maps.Marker(marker_options);
      map.markers.push(marker);
    },
  },

  forms: {
    init: function () {
      $("#contact-form").submit(function (e) {
        e.preventDefault();
        var self = $(this);

        if (helpers.validate($("#contact-form"))) {
          $.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
              action: "submit_cform",
              "contact-name": $("#name").val(),
              "contact-surname": $("#surname").val(),
              "contact-phone": $("#phone").val(),
              "contact-email": $("#email").val(),
              "contact-topic": $("#topic").val(),
              "contact-message": $("#message").val(),
              "contact-nonce": $("#contact-nonce").val(),
              "contact-honey": $("#contact-honey").val(),
              "post-id": $("#post_id").val(),
            },
            beforeSend: function () {
              $(".form__status").addClass("hidden");
              $("#contact-form button, .contacts__form").addClass("loading");
            },
          }).done(function (response) {
            $("#contact-form button, .contacts__form").removeClass("loading");
            if (response.success) {
              $(".errors-wrap").remove();
              $(".form__status")
                .removeClass("error")
                .text(response.data.message)
                .removeClass("hidden");
              $("#contact-form")[0].reset();
              grecaptcha.reset();
              $("#contact-form").find("input, textarea").blur();
            } else {
              $(".form__status")
                .addClass("error")
                .text(response.data.message)
                .removeClass("hidden");
            }
          });
        }
      });
    },
  },
};
export default contacts;
